export const version = 'v2.2.4-1502-gd0af0c26'
